/**
 * Кастомные события аналитики bookva.cz → Web Pixels API.
 *
 * Шлём только то, чего Shopify не знает сам. Стандартную воронку
 * (view_item, add_to_cart, purchase) публикует приложение Google & YouTube,
 * здесь её нет.
 *
 * Контекст страницы приходит из snippets/bk-analytics.liquid как JSON
 * в #bk-analytics-config — конкатенации строк в Liquid нет, всё через `| json`.
 *
 * События: bookva:back_in_stock_subscribe, bookva:meta_lead, bookva:search,
 * bookva:filter_applied, bookva:newsletter_signup, bookva:language_switch.
 */
(function () {
  'use strict';

  var CONFIG = readConfig();
  var LANG = CONFIG.lang || '';

  /** sessionStorage в приватном окне бросает на доступе, а не отдаёт null. */
  function storage(fn, fallback) {
    try {
      return fn(window.sessionStorage);
    } catch (error) {
      return fallback;
    }
  }

  function readConfig() {
    var node = document.getElementById('bk-analytics-config');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[bk-analytics] битый конфиг страницы', error);
      return {};
    }
  }

  /**
   * `Shopify.analytics.publish` объявлен в content_for_header и до загрузки
   * менеджера пикселей сам складывает вызовы в replayQueue. Отдельная очередь
   * нам не нужна — достаточно не падать, если объекта нет вовсе.
   */
  function publish(name, payload) {
    try {
      var analytics = window.Shopify && window.Shopify.analytics;

      if (analytics && typeof analytics.publish === 'function') {
        analytics.publish(name, payload);
        return;
      }

      if (analytics && Array.isArray(analytics.replayQueue)) {
        analytics.replayQueue.push([name, payload]);
        return;
      }

      console.warn('[bk-analytics] Shopify.analytics недоступен, событие потеряно:', name);
    } catch (error) {
      console.warn('[bk-analytics] publish упал:', name, error);
    }
  }

  /**
   * `search.terms` приезжает из Shopify уже HTML-экранированным: запрос
   * «п'ять» доходит как «п&#39;ять». В отчёт такое пускать нельзя, а фильтра
   * обратного `escape` в Liquid нет — раскодируем на клиенте.
   */
  function decodeEntities(text) {
    if (!text || text.indexOf('&') === -1) return text || '';
    var buffer = document.createElement('textarea');
    buffer.innerHTML = text;
    return buffer.value;
  }

  /** Копейки Shopify → кроны. 26900 → 269, 18990 → 189.9. */
  function toMajorUnits(cents) {
    var value = Number(cents);
    return Number.isFinite(value) ? Math.round(value) / 100 : null;
  }

  // ── 1. Подписка на наличие ────────────────────────────────────────────
  //
  // Главная конверсия магазина: покупка невозможна на 97 % страниц.
  //
  // Событие приложения STOQ, ленивый чанк restockrocket-modal. В detail лежат
  // полный product JSON и объект варианта, поэтому подписка из сетки коллекции
  // считается так же, как с карточки товара, — карта товаров в шаблоне
  // листинга не нужна.
  window.addEventListener('stoq:restock-modal:submitted', function (event) {
    var detail = event.detail || {};
    var product = detail.product || {};
    var variant = detail.variant || {};

    var payload = {
      currency: 'CZK',
      in_stock: variant.available ? 'true' : 'false',
      content_language: LANG,
      variant_id: variant.id == null ? '' : String(variant.id),
      items: [
        {
          item_id: variant.sku || '',
          item_name: product.title || '',
          item_brand: product.vendor || '',
        },
      ],
    };

    var value = toMajorUnits(variant.price);
    if (value === null) {
      console.warn('[bk-analytics] у варианта нет цены, событие без value', variant);
    } else {
      payload.value = value;
    }

    publish('bookva:back_in_stock_subscribe', payload);
    publishMetaLead(detail, product);
  });

  // ── 1а. Lead для Meta CAPI ────────────────────────────────────────────
  //
  // Отдельное событие, а не поле в back_in_stock_subscribe: на то событие
  // подписан пиксель GTM и кладёт payload в dataLayer целиком, а хеш email
  // в Google попадать не должен. bookva:meta_lead слушает только пиксель
  // «Meta Lead» (local_scripts/bk-meta-lead-pixel.js), он шлёт на VPS.
  //
  // Сырой email со страницы не уходит: SHA-256 считается здесь, в
  // Shopify.analytics попадает только хеш. Нормализация по требованию Meta —
  // trim и нижний регистр. Без согласия на маркетинг хеш не считается вовсе;
  // пиксель проверяет согласие ещё раз.
  //
  // product_id — id товара Shopify: канал Facebook & Instagram шлёт в
  // content_ids именно его (content_type product_group), по нему Meta
  // сводит событие с каталогом.
  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
    } catch (error) {
      return false;
    }
  }

  function sha256Hex(text) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buffer) {
      return Array.from(new Uint8Array(buffer), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function publishMetaLead(detail, product) {
    var email = detail.customer && detail.customer.email;
    if (typeof email !== 'string' || !email.trim()) return;
    if (!marketingAllowed()) return;
    if (!window.crypto || !window.crypto.subtle) return;

    sha256Hex(email.trim().toLowerCase())
      .then(function (em) {
        publish('bookva:meta_lead', {
          em: em,
          product_id: product.id == null ? '' : String(product.id),
        });
      })
      .catch(function (error) {
        console.warn('[bk-analytics] хеш email не посчитан', error);
      });
  }

  // ── 2. Поиск ──────────────────────────────────────────────────────────
  //
  // Один раз на загрузку страницы результатов. Фасеты на ней меняют выдачу
  // через Section Rendering API без перезагрузки — это уже filter_applied.
  if (CONFIG.search) {
    var count = Number(CONFIG.search.count) || 0;

    publish('bookva:search', {
      search_term: decodeEntities(CONFIG.search.term),
      search_results_count: count,
      search_has_results: count > 0 ? 'true' : 'false',
      content_language: LANG,
    });
  }

  // ── 3. Применён фильтр ────────────────────────────────────────────────
  //
  // Слушатель на document, а не на фасетах: секция результатов
  // перерисовывается Section Rendering API, и обработчик на её разметке
  // отвалился бы после первого же фильтра.

  /**
   * Имена фасетов задаются в Search & Discovery, а не в теме, поэтому список
   * явный: новый фильтр не должен молча уехать в отчёт под своим внутренним
   * именем и там потеряться. Незнакомый ключ → `unknown` плюс предупреждение
   * в консоль, это сигнал дописать маппинг.
   *
   * `year` в магазине пока не заведён и лежит здесь на будущее.
   * `availability` заведён, но в контракте GA4 его нет — см. DONEv7.
   */
  var FILTER_NAMES = {
    'filter.p.m.book.author': 'author',
    'filter.p.m.book.publisher': 'publisher',
    'filter.p.m.book.genre': 'genre',
    'filter.p.m.book.age_group': 'age',
    'filter.p.m.book.language': 'language',
    'filter.p.m.book.binding': 'binding',
    'filter.p.m.book.year': 'year',
    'filter.v.availability': 'availability',
    'filter.v.price': 'price',
  };

  function filterName(paramName) {
    // Границы цены приходят двумя параметрами, фильтр при этом один.
    var key = paramName.replace(/\.(gte|lte)$/, '');
    var name = FILTER_NAMES[key];

    if (!name) {
      console.warn('[bk-analytics] незнакомый фильтр, нужен маппинг:', paramName);
      return 'unknown';
    }

    return name;
  }

  /** Подпись значения, как её видит покупатель; иначе — сырое значение. */
  function filterValue(input) {
    var label = input
      .closest('.bkv-facet__value')
      ?.querySelector('.bkv-facet__value-text');

    return (label && label.textContent.trim()) || input.value;
  }

  /** Границы цены как «100-250»; открытый конец остаётся пустым. */
  function priceValue(facet) {
    var inputs = facet.querySelectorAll('input[name^="filter.v.price"]');
    var bounds = ['', ''];

    for (var i = 0; i < inputs.length; i++) {
      bounds[/\.lte$/.test(inputs[i].name) ? 1 : 0] = inputs[i].value;
    }

    return bounds.join('-');
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    // Ползунки цены сами по себе безымянные: фильтрует форма числовыми полями.
    var priceFacet = input.closest('bkv-price-facet');
    if (priceFacet) {
      publish('bookva:filter_applied', {
        filter_name: 'price',
        filter_value: priceValue(priceFacet),
        content_language: LANG,
      });
      return;
    }

    if (input.name.indexOf('filter.') !== 0) return;
    // Снятие галки — это не «применён фильтр».
    if (input.type === 'checkbox' && !input.checked) return;

    publish('bookva:filter_applied', {
      filter_name: filterName(input.name),
      filter_value: filterValue(input),
      content_language: LANG,
    });
  });

  // ── 4. Подписка на рассылку ───────────────────────────────────────────
  //
  // Штатный блок email-signup правке не подлежит, поэтому ловим в два шага:
  // помечаем отправку, публикуем после редиректа Shopify на
  // ?customer_posted=true. Без метки не публикуем — иначе перезагрузка
  // страницы с этим параметром в URL дала бы второе событие.
  var NEWSLETTER_KEY = 'bk-analytics:newsletter';

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var formType = form.querySelector('input[name="form_type"]');
    if (!formType || formType.value !== 'customer') return;

    var method = form.closest('footer')
      ? 'footer'
      : form.closest('[data-bk-newsletter]')
        ? 'homepage'
        : 'popup';
    storage(function (store) {
      store.setItem(NEWSLETTER_KEY, method);
    });
  });

  if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
    var method = storage(function (store) {
      var stored = store.getItem(NEWSLETTER_KEY);
      store.removeItem(NEWSLETTER_KEY);
      return stored;
    }, null);

    if (method) {
      publish('bookva:newsletter_signup', {
        method: method,
        content_language: LANG,
      });
    }
  }

  // ── 5. Переключение языка ─────────────────────────────────────────────
  //
  // Переключатель — обычный submit формы localization, то есть полная
  // перезагрузка: событие, отправленное по клику, не доживёт до пикселя.
  // Поэтому сравниваем локаль с прошлой страницей уже после перехода.
  var LANG_KEY = 'bk-analytics:lang';

  if (LANG) {
    var previous = storage(function (store) {
      return store.getItem(LANG_KEY);
    }, null);

    if (previous && previous !== LANG) {
      publish('bookva:language_switch', { from: previous, to: LANG });
    }

    storage(function (store) {
      store.setItem(LANG_KEY, LANG);
    });
  }
})();
